import React from "react";

export const Container=(props)=>{
   const {xsmall,small,medium,large,xlarge,xxlarge}=props;
    let containerClass='container';
    if(xsmall){
        containerClass+='-xs'
    }
    else if(small)
    containerClass+='-sm'
    else if(medium){
        containerClass+='-md';
    } else if(large){
        containerClass+='-lg'
    }
    else if(xlarge){
        containerClass+='-xl'
    }
    else if(xxlarge){
        containerClass+='-xxl'
    }
    return(<div className={containerClass}>{props.children}</div>)
}